module.exports = "/_next/static/images/458f191347ce6cb11d1be4a062a31bb3-roxinho-single-xs@2x.jpg.webp";